import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { EntryCardShareButton, SafetyShadow } from '@/components/entry-card';
import { Column, Row } from '@/components/lib/components';
import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';

type Props = {
    /** Date line shown above the entry id — "Placed: …" for open entries, "Settled: …" once settled. */
    dateLine?: string;
    entryId: string;
    onSharePress?: () => void;
};

/** Renders the date line, entry ID, and an optional share button for a sportsbook entry card. */
export const SbkEntryCardBottom = ({ dateLine, entryId, onSharePress }: Props) => {
    const { t } = useTranslation('bets');
    const isPredictions = useIsPredictionsProduct();
    const idLabel = isPredictions ? t('position_id') : t('entry_id');
    return (
        <Row paddingHorizontal="s16" alignItems="center" justifyContent="space-between" gap="s16">
            <Column flex={1} gap="s2" style={styles.textColumn}>
                {dateLine ? (
                    <Text
                        variant="bodySmaller"
                        lineHeight={16}
                        color="neutral300"
                        numberOfLines={1}
                        ellipsizeMode="clip"
                    >
                        {dateLine}
                    </Text>
                ) : null}
                <Text variant="bodySmaller" lineHeight={16} color="neutral300" numberOfLines={1} ellipsizeMode="clip">
                    {`${idLabel}: ${entryId}`}
                </Text>
                <SafetyShadow style={styles.shadow} />
            </Column>
            {onSharePress ? <EntryCardShareButton onPress={onSharePress} /> : null}
        </Row>
    );
};

const styles = StyleSheet.create({
    textColumn: { overflow: 'hidden' },
    shadow: { position: 'absolute', top: 0, right: 0, bottom: 0, width: 32 },
});
